var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.497 15.48C12.0517 15.48 11.6717 15.3217 11.357 15.005C11.0423 14.6883 10.885 14.3073 10.885 13.862C10.885 13.4167 11.0433 13.0367 11.36 12.722C11.6767 12.4073 12.058 12.25 12.504 12.25C12.95 12.25 13.33 12.4087 13.644 12.726C13.958 13.0433 14.1153 13.4243 14.116 13.869C14.1167 14.3137 13.958 14.6937 13.64 15.009C13.322 15.3243 12.941 15.4817 12.497 15.481M8.60007 7.19194C8.7684 7.53362 9.11622 7.75 9.49711 7.75H15.5028C15.8837 7.75 16.2316 7.53356 16.3999 7.1918L17.4 5.161C17.5413 4.89233 17.5353 4.63167 17.382 4.379C17.2287 4.12633 16.9987 4 16.692 4H8.308C8.00133 4 7.77133 4.12633 7.618 4.379C7.46467 4.63167 7.45867 4.89267 7.6 5.162L8.60007 7.19194ZM9.131 20H15.869C17.1557 20 18.249 19.5497 19.149 18.649C20.0497 17.7483 20.5 16.653 20.5 15.363C20.5 14.8243 20.4077 14.2997 20.223 13.789C20.0383 13.2783 19.7717 12.8133 19.423 12.394L16.6808 9.10915C16.4908 8.88156 16.2096 8.75 15.9132 8.75H9.08685C8.79037 8.75 8.50918 8.88156 8.31918 9.10915L5.577 12.394C5.22833 12.8133 4.96167 13.2783 4.777 13.789C4.59233 14.299 4.5 14.8237 4.5 15.363C4.5 16.653 4.95033 17.7483 5.851 18.649C6.75167 19.5497 7.845 20 9.131 20Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBag);
export default __webpack_public_path__ + "static/media/icon_bag.003c1ef802d0bba868df9046609c179c.svg";
export { ForwardRef as ReactComponent };